import React from 'react';
import '../App.css';

export default function About() {
  return (
    <div className="App">
      <header className="hero">
        <h1 className="hero-title">About RUNIC Solutions</h1>
        <p className="hero-subtitle">
          We craft elegant, modern software to empower teams and businesses.
        </p>
      </header>

      <section className="services">
        <h2>Our Philosophy</h2>
        <div className="service-cards">
          <div className="card">
            <h3>Security</h3>
            <p>We build secure software from the ground up, not as an afterthought.
            </p>
          </div>
          <div className="card">
            <h3>Privacy</h3>
            <p>We protect user data and prioritize private-first product decisions.</p>
          </div>
          <div className="card">
            <h3>Quality Over Predatory Profits</h3>
            <p>We choose long-term product quality and user trust over short-term, predatory monetization.</p>
          </div>
        </div>
      </section>

      {/* Founders Section */}
      <section className="services" id="founders">
        <h2>Founders</h2>
        <div className="service-cards">
          {/* Founder 1 */}
          <a
            href="https://nicholaslaureano.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <div className="card" style={{ textAlign: 'center' }}>
              <img
                src="/nick.jpeg"
                alt="Founder 1 headshot"
                style={{
                  width: 180,
                  height: 180,
                  objectFit: 'cover',
                  borderRadius: '50%',
                  display: 'block',
                  margin: '0 auto 12px'
                }}
              />
              <h3 style={{ marginBottom: 8 }}>Nicholas Laureano</h3>
              <p style={{ margin: 0, color: '#4b5563' }}>
                Former Microsoft Software Engineer with a passion for building impactful software.
              </p>
            </div>
          </a>

          {/* Founder 2 */}
          <div className="card" style={{ textAlign: 'center' }}>
            <img
              src="/Raul.jpg"
              alt="Founder 2 headshot"
              style={{
                width: 180,
                height: 180,
                objectFit: 'cover',
                borderRadius: '50%',
                display: 'block',
                margin: '0 auto 12px'
              }}
            />
            <h3 style={{ marginBottom: 8 }}>Raul Lopez Toledo</h3>
            <p style={{ margin: 0, color: '#4b5563' }}>
              Former Nunez Engineer and UO Security Analyst, dedicated to building secure and efficient software solutions.
            </p>
          </div>
        </div>
        <p style={{ marginTop: 12, fontSize: 14, color: '#6b7280' }}>
          Our founders bring a wealth of experience from top tech companies and a
          passion for building impactful software.
        </p>
      </section>

      <footer className="footer">
        <p>© 2025 RUNIC Solutions — Purposeful technology.</p>
      </footer>
    </div>
  );
}
